import React from 'react';

export const NatureCircleIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <circle cx="32" cy="32" r="28" fill="#E6D3A3" stroke="#6D4C41" strokeWidth="2" />
      <polygon points="32,15 22,30 42,30" fill="#2E7D32" />
      <polygon points="32,23 20,40 44,40" fill="#388E3C" />
      <rect x="29" y="40" width="6" height="10" rx="1.5" fill="#6D4C41" />
      <circle cx="22" cy="22" r="2" fill="#A5D6A7" />
      <circle cx="42" cy="24" r="2" fill="#A5D6A7" />
    </svg>
  );
};
